const categories = [
  { icon: 'ri-heart-pulse-line', name: '恋爱甜宠', count: '8,520部', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-sword-line', name: '热血战斗', count: '6,830部', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-magic-line', name: '奇幻冒险', count: '7,210部', color: 'bg-secondary-100 text-secondary-600' },
  { icon: 'ri-ghost-line', name: '悬疑推理', count: '4,560部', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-building-2-line', name: '都市职场', count: '5,340部', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-landscape-line', name: '古风仙侠', count: '6,120部', color: 'bg-secondary-100 text-secondary-600' },
  { icon: 'ri-emotion-laugh-line', name: '搞笑日常', count: '4,890部', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-rocket-line', name: '科幻未来', count: '3,780部', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            漫画分类
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            全部分类，一网打尽
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            八大主题分类，助你快速找到想看的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((item) => (
            <div
              key={item.name}
              className="group flex flex-col items-center p-4 md:p-5 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${item.color} mb-3 group-hover:scale-110 transition-transform duration-200`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap font-heading">
                {item.name}
              </h3>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}